/** 正文设备链接预览小窗状态（产品内容 / 分类逐级列表） */
import { reactive } from 'vue'

export const productContentPreview = reactive({
  visible: false,
  view: 'product',
  productId: '',
  categoryId: '',
  categoryTitle: '',
  categoryStack: [],
})

function setCategoryLevel(categoryId, categoryTitle, { resetStack = false } = {}) {
  const id = String(categoryId || '')
  const title = String(categoryTitle || '')
  if (!id) return
  productContentPreview.categoryId = id
  productContentPreview.categoryTitle = title
  productContentPreview.productId = ''
  productContentPreview.view = 'category'
  productContentPreview.visible = true

  if (resetStack) {
    productContentPreview.categoryStack = [{ id, title }]
    return
  }

  const stack = Array.isArray(productContentPreview.categoryStack)
    ? [...productContentPreview.categoryStack]
    : []
  const last = stack[stack.length - 1]
  if (!last || String(last.id) !== id) {
    stack.push({ id, title })
  } else if (title && !last.title) {
    stack[stack.length - 1] = { id, title }
  }
  productContentPreview.categoryStack = stack
}

export function openProductContentPreview(productId, { fromCategory = false } = {}) {
  const id = String(productId || '')
  if (!id) return
  productContentPreview.productId = id
  productContentPreview.view = 'product'
  productContentPreview.visible = true
  if (!fromCategory) {
    productContentPreview.categoryId = ''
    productContentPreview.categoryTitle = ''
    productContentPreview.categoryStack = []
  }
}

export function openCategoryDevicePreview(categoryId, categoryTitle = '') {
  setCategoryLevel(categoryId, categoryTitle, { resetStack: true })
}

export function drillCategoryPreview(categoryId, categoryTitle = '') {
  setCategoryLevel(categoryId, categoryTitle, { resetStack: false })
}

export function showProductFromCategory(productId) {
  openProductContentPreview(productId, { fromCategory: true })
}

export function backToCategoryPreview() {
  const stack = productContentPreview.categoryStack || []
  if (productContentPreview.view === 'product' && productContentPreview.categoryId) {
    productContentPreview.view = 'category'
    productContentPreview.productId = ''
    return
  }
  if (stack.length <= 1) return
  const next = stack.slice(0, -1)
  const parent = next[next.length - 1]
  productContentPreview.categoryStack = next
  productContentPreview.categoryId = parent?.id || ''
  productContentPreview.categoryTitle = parent?.title || ''
  productContentPreview.view = 'category'
  productContentPreview.productId = ''
}

export function closeProductContentPreview() {
  productContentPreview.visible = false
  productContentPreview.view = 'product'
  productContentPreview.productId = ''
  productContentPreview.categoryId = ''
  productContentPreview.categoryTitle = ''
  productContentPreview.categoryStack = []
}
